import { render, staticRenderFns } from "./specificCompanyLogin.vue?vue&type=template&id=5f55cba2&"
import script from "./specificCompanyLogin.vue?vue&type=script&lang=js&"
export * from "./specificCompanyLogin.vue?vue&type=script&lang=js&"
import style0 from "./specificCompanyLogin.vue?vue&type=style&index=0&id=5f55cba2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports